import { createSelector } from 'reselect';

import { StateType } from '@redux/reducers';

const getBillingState = ({ conciergeBillings }: StateType) => conciergeBillings;

export const billingConciergeDetailsSelector = createSelector(
  [getBillingState],
  ({ billingDetails }) => billingDetails
);
export const billingConciergePriceRangeSelector = createSelector(
  [getBillingState],
  ({ billingPriceRange }) => billingPriceRange
);
export const orderConciergePriceRangeSelector = createSelector(
  [getBillingState],
  ({ orderPriceRange }) => orderPriceRange
);
export const billingConciergeAddressSelector = createSelector(
  [getBillingState],
  ({ billingAddress }) => billingAddress
);
